// extracted by mini-css-extract-plugin
export var active = "_5w-b";
export var activeIndicator = "_5w-6";
export var animate = "_5w-a";
export var disabled = "_5w-c";
export var flat = "_5w-1";
export var fullWidth = "_5w-3";
export var lg = "_5w-9";
export var md = "_5w-8";
export var redoButtonTabGroup = "_5w-0";
export var sm = "_5w-7";
export var tabButton = "_5w-4";
export var tabButtonsContainer = "_5w-2";
export var xs = "_5w-5";